import {Component, Injector, OnDestroy, OnInit } from '@angular/core';
import {BaseDialogTemplateComponent } from '../base-dialog-template.component';
import {interval, Subscription, takeUntil} from 'rxjs';
import {TimeUtil} from "../../../../../shared/utils/time-util";
import {ocppConnector} from "../../../../../shared/models/ocppConnector.model";
import {NGSIEventType, Notification} from "../../../../../shared/models/notification.model";

@Component({
  selector: 'ocppChargePoint-dialog-template',
  templateUrl: './ocppChargePoint-dialog-template.component.html',
  styleUrls: ['./ocppChargePoint-dialog-template.component.scss']
})

/*
* TO DO: The constant time value for Not Connected state should be decided and revised in ocppConnector.model.ts file */
export class OcppChargePointDialogTemplateComponent extends BaseDialogTemplateComponent implements OnInit, OnDestroy {

  // Context variables
  ocppChargePointEntity: any;
  ocppAuthorizeEntity: any;
  ocppBootNotificationEntity: any;
  ocppConnectorEntity: any;

  // ocppChargePointEntity variables
  chargePointId: any;
  location: any;
  heartBeatTime: any;
  chargePointTime: any;
  // true if connected, false if not connected
  chargePointConnectionStatus: boolean = true;

  // ocppAuthorizeEntity variables
  vin: any;

  // ocppBootNotificationEntity variables
  vendor: any;
  modelNo: any;
  serialNumber: any;
  firmware: any;

  // ocppConnectorEntity variables
  // Each ocppConnector element holds ocppConnectorId, ocppStatus, ocppStatusTime, ocppErrorCode, socUnit, socValue, ocppIcon, ocppIconColor values
  ocppConnectors : ocppConnector[] = [];

  // variables related to ocppConnector numbers and number of active connector
  connectorCount: number = 0;
  connectorNumbers: any[] = [];
  activeConnectorNo: number = 0;   // By default, first connector is set as the active one until a user tab change

  // variables to be written in html template
  ocppStatus: any = "No Connector";  // In case there is no connector
  chargeTime: any = '';

  ocppStatusDetail: string;
  ocppStatusDescriptionIcon: string ="";

  // css class info for the header part of html template
  ocppStyle :any;

  statusColor: any ='white';
  outerBackground: string ='black';

  // to update the charging time for an active connector in the Charging state
  private refreshChargeTime: Subscription;

  // keeps the active tab
  activeTab: string;

  showFooter: boolean = true;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.subscribeWebsocket();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.refreshChargeTime)
      this.refreshChargeTime.unsubscribe();
  }

  protected mapContextData(context: any): void {
    this.ocppChargePointEntity = context.entity ? context.entity : null;
    this.ocppConnectorEntity = context.ocppConnectorEntity ? context.ocppConnectorEntity : null;
    this.ocppAuthorizeEntity = context.ocppAuthorizeEntity ? context.ocppAuthorizeEntity : null;
    this.ocppBootNotificationEntity = context.ocppBootNotificationEntity ? context.ocppBootNotificationEntity : null;

    if ( (this.ocppChargePointEntity !== null) && (this.ocppChargePointEntity.results.length > 0) ) {
      this.chargePointId = this.ocppChargePointEntity.results[0].result.entity ?  this.ocppChargePointEntity.results[0].result.entity.id : null;
      this.location = this.ocppChargePointEntity.results[0].result.entity.location ?  this.ocppChargePointEntity.results[0].result.entity.location.value.coordinates.join(', ') : '-';
      this.heartBeatTime = this.ocppChargePointEntity.results[0].result.entity.heartbeat ?  this.ocppChargePointEntity.results[0].result.entity.heartbeat.observedAt : null;
      this.chargePointTime = this.ocppChargePointEntity.results[0].result.entity.description ?  this.ocppChargePointEntity.results[0].result.entity.description.observedAt : null;
      this.chargePointConnectionStatus = this.checkChargePointConnectionStatus(this.heartBeatTime, this.chargePointTime);
    }
    if ( (this.ocppAuthorizeEntity !== null) && (this.ocppAuthorizeEntity.results.length > 0) )
      this.vin = this.ocppAuthorizeEntity.results[0].result.entity.idTag ? this.ocppAuthorizeEntity.results[0].result.entity.idTag.value : '-';
    if ( (this.ocppBootNotificationEntity !== null) && (this.ocppBootNotificationEntity.results.length > 0) ) {
      this.vendor = this.ocppBootNotificationEntity.results[0].result.entity.chargePointVendor ? this.ocppBootNotificationEntity.results[0].result.entity.chargePointVendor.value : '-';
      this.modelNo = this.ocppBootNotificationEntity.results[0].result.entity.chargePointModel ? this.ocppBootNotificationEntity.results[0].result.entity.chargePointModel.value : '-';
      this.serialNumber = this.ocppBootNotificationEntity.results[0].result.entity.chargePointSerialNumber ? this.ocppBootNotificationEntity.results[0].result.entity.chargePointSerialNumber.value : '-';
      this.firmware = this.ocppBootNotificationEntity.results[0].result.entity.firmwareVersion ? this.ocppBootNotificationEntity.results[0].result.entity.firmwareVersion.value : '-';
    }
    if ( (this.ocppConnectorEntity != null ) && (this.ocppConnectorEntity.results.length > 0) ) {
      for (let i = 0; i < this.ocppConnectorEntity.results.length; i++) {
        const ocppConnectorValue = this.ocppConnectorEntity.results[i];
        this.ocppConnectors.push(new ocppConnector( {
          ocppConnectorId: ocppConnectorValue.result.entity.id ? ocppConnectorValue.result.entity.id : '',
          ocppStatus: ocppConnectorValue.result.entity.status ? ocppConnectorValue.result.entity.status.value : 'No Status',
          // MAY NEED TO BE MODIFIED ACCORDING TO ACTUAL OCPP VALUES FROM SITE, CHECK WHETHER status.observedAt IS THE APPROPRIATE ALTERNATIVE TIME FOR STATUS TIME
          ocppStatusTime: ocppConnectorValue.result.entity.statusTimestamp ? ocppConnectorValue.result.entity.statusTimestamp.value :
          (ocppConnectorValue.result.entity.status ? ocppConnectorValue.result.entity.status.observedAt : null),
          ocppErrorCode: ocppConnectorValue.result.entity.errorCode ? ocppConnectorValue.result.entity.errorCode.value : null,
          socUnit: ocppConnectorValue.result.entity.soc ? ocppConnectorValue.result.entity.soc.value.unit : null,
          socValue: ocppConnectorValue.result.entity.soc ? ocppConnectorValue.result.entity.soc.value.value : null,
        }));
        if (this.chargePointConnectionStatus === false) {
          this.ocppConnectors[i].ocppStatus = 'Not Connected';
          this.ocppConnectors[i].setOcppIcon('Not Connected');
        }
      }
      this.sortConnectors();
      // activeConnectorNo initial value is 0
      this.changeOcppValues();
    }
    // If Charge Point has no connector
    else {
      // Initial value for ocppStatus is "No Connector"
      this.setStatusStyle();
    }
  }

  //checks if the charge point is in Not Connected status using the time of the last message received from the Charge Point
  //returns true if the last heart beat time received is smaller than DURATIONFORNOTCONNECTED i.e. 24*60 minutes
  //otherwise returns false which means the charge point and all its connectors are in Not Connected state
  checkChargePointConnectionStatus(heartbeatTime, chargePointTime) : boolean {
    const currentTime: any = TimeUtil.now();
    let observedAtTime: Date;

    if (heartbeatTime != null) {
      observedAtTime = new Date(heartbeatTime);
      if ( ( ( currentTime.getTime() - observedAtTime.getTime() ) / 60000 ) <= ocppConnector.durationForNotConnected )
        return true;
    }
    if (chargePointTime != null) {
      observedAtTime = new Date(chargePointTime);
      if ( ( ( currentTime.getTime() - observedAtTime.getTime() ) / 60000 ) <= ocppConnector.durationForNotConnected )
        return true;
    }
    return false;
  }

  sortConnectors() : void {
    this.connectorCount = this.ocppConnectors.length;
    if (this.connectorCount>1)
      this.ocppConnectors.sort(function (a, b) {return a.ocppConnectorId.localeCompare(b.ocppConnectorId)});
    this.connectorNumbers = [];
    for (let i=0; i<this.connectorCount;i++) {
      let connId: string =  this.ocppConnectors[i].ocppConnectorId;
      let connNumber: string = connId[connId.length-1];
      for (let j = connId.length-2; j>=0; j--) {
        if ( (connId[j] >= '0') && (connId[j] <= '9') )
          connNumber = connId[j] + connNumber;
        else
          break;
      }
      this.connectorNumbers.push(connNumber);
    }
  }

  // The function that changes the connector info displayed in html template
  private changeOcppValues() {
    this.chargeTime = this.calculateChargingTime();
    this.ocppStatus = this.ocppConnectors[this.activeConnectorNo].ocppStatus;
    this.setStatusStyle(this.ocppConnectors[this.activeConnectorNo]);
    this.activateChargingTimer();
  }

  calculateChargingTime(): string {
    const chargeTime : any = this.ocppConnectors[this.activeConnectorNo].ocppStatusTime;
    if (chargeTime !== null) {
      const currentTime: any = TimeUtil.now();
      const observedAtTime = new Date(chargeTime);
      const diffMs = currentTime.getTime() - observedAtTime.getTime();
      let chargingTime:string;
      if (diffMs > 0) {
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
        const diffSeconds = Math.floor((diffMs % (1000 * 60)) / 1000);
        const formattedDays = diffDays.toString().padStart(2, '0');
        const formattedHours = diffHours.toString().padStart(2, '0');
        const formattedMinutes = diffMinutes.toString().padStart(2, '0');
        const formattedSeconds = diffSeconds.toString().padStart(2, '0');
          chargingTime = (diffDays > 0) ? (formattedDays +" : " +formattedHours +" : " +formattedMinutes +" : " +formattedSeconds) : (formattedHours +" : " +formattedMinutes +" : " +formattedSeconds);
        return chargingTime;
      }
    }
    return '';
  }

// Set some status and text information displayed in html template for the selected (active) connector in the charge point
  setStatusStyle(activeConn?) {
// If the charge point does not have a connector, set style and text accordingly
    if (!activeConn) {
      this.outerBackground = 'linear-gradient(268.3deg, #747474 48.56%, #B4B4B4 116.26%)';
      this.statusColor = '#D1D1D1';
      this.ocppStyle = 'info-ocpp-unavailable';
      this.ocppStatusDetail = 'ocppNoConnectorDetail';
      return;
    }
// Set style and text in accordance with the status of the active (selected) connector
    switch (activeConn.ocppStatus) {
      case "Available":
        this.outerBackground = 'linear-gradient(268.3deg, #008605 48.56%, #19D279 116.26%)';
        this.statusColor = '#FFFFFF';
        this.ocppStyle = 'info-ocpp-available';
        this.ocppStatusDetail = 'ocppAvailableDetail';
        this.ocppStatusDescriptionIcon = "assets/images/Hazir.svg";
        break;
      case "Charging":
        if (activeConn.socValue === '')
          this.outerBackground = `#292929`;
        else
          this.outerBackground = `conic-gradient(#46A3FF 0% ${activeConn.socValue}%, #292929 ${activeConn.socValue}% 100%)`;
        this.statusColor = '#FFFFFF';
        this.ocppStyle = 'info-ocpp-charging';
        this.ocppStatusDetail = '';
        break;
      case "Preparing":
        this.outerBackground = 'linear-gradient(269.57deg, #0066FF 0.39%, #0069F8 23.22%, #05929B 49.02%, #09B844 80.29%, #0AC032 99.64%)';
        this.statusColor = '#FFFFFF';
        this.ocppStyle = 'info-ocpp-available';
        this.ocppStatusDetail = 'ocppPreparingDetail';
        this.ocppStatusDescriptionIcon = "assets/images/Hazirlaniyor.svg";
        break;
      case "Finishing":
        this.outerBackground = 'linear-gradient(266.6deg, #1976D2 94.39%, #46A3FF 226.01%)';
        this.statusColor = '#FFFFFF';
        this.ocppStyle = 'info-ocpp-charging';
        this.ocppStatusDetail = 'ocppFinishingDetail';
        this.ocppStatusDescriptionIcon = "assets/images/SarjSonlaniyor.svg";
        break;
      case "Faulted":
        this.outerBackground = 'linear-gradient(268.3deg, #D21919 48.56%, #FF8282 116.26%)';
        this.statusColor = '#FF0026';
        this.ocppStyle = 'info-ocpp-faulted';
        this.ocppStatusDetail = activeConn.ocppErrorCode ? activeConn.ocppErrorCode : '';
        this.ocppStatusDescriptionIcon = "assets/images/Hata.svg";
        break;
      case "SuspendedEVSE":
      case "SuspendedEV":
        if (activeConn.socValue === '')
          this.outerBackground = `conic-gradient(#E2931D 0% 50%, #292929 50% 100%)`;
        else
          this.outerBackground = `conic-gradient(#E2931D 0% ${activeConn.socValue}%, #292929 ${activeConn.socValue}% 100%)`;
        this.statusColor = '#FFFFFF';
        this.ocppStyle = 'info-ocpp-suspended';
        if (activeConn.ocppStatus === 'SuspendedEVSE') {
          this.ocppStatusDetail = 'ocppSuspendedEVSEDetail';
          this.ocppStatusDescriptionIcon = "assets/images/SarjBeklemedeEVSE.svg";
        }
        else {
          this.ocppStatusDetail = 'ocppSuspendedEVDetail';
          this.ocppStatusDescriptionIcon = "assets/images/SarjBeklemedeEV.svg";
        }
        break;
      case "Reserved":
        this.outerBackground = 'linear-gradient(268.3deg, #8D00A4 48.56%, #A84BF1 116.26%)';
        this.statusColor = '#FFFFFF';
        this.ocppStyle = 'info-ocpp-reserved';
        this.ocppStatusDetail = 'ocppReservedDetail';
        this.ocppStatusDescriptionIcon = "assets/images/Rezerve.svg";
        break;
      case "Unavailable":
      case "Not Connected":
      case "No Status":
      default:
        this.outerBackground = 'linear-gradient(268.3deg, #747474 48.56%, #B4B4B4 116.26%)';
        this.statusColor = '#D1D1D1';
        this.ocppStyle = 'info-ocpp-unavailable';
        this.ocppStatusDescriptionIcon = "assets/images/SistemDisi.svg";
        if (activeConn.ocppStatus === 'Unavailable')
          this.ocppStatusDetail = 'ocppUnavailableDetail';
        else if (activeConn.ocppStatus === 'Not Connected')
          this.ocppStatusDetail = 'ocppNotConnectedDetail';
        else
          this.ocppStatusDetail = 'ocppNoStatusDetail';
        break;
    }
  }

// If the active connector is in Charging State, starts a 1-second timer to change charging time info in real time
  private activateChargingTimer() {
    if (this.ocppStatus === 'Charging') {
      if (!this.refreshChargeTime) {
//      if ( (!this.refreshChargeTime) || (this.refreshChargeTime.closed) ) {
        this.refreshChargeTime = interval(1000).subscribe(() => {
          this.chargeTime = this.calculateChargingTime();
        });
      }
    }
    /*    else {
          if (this.refreshChargeTime)
            this.refreshChargeTime.unsubscribe();
        }*/

  }

  // When the user selects another connector by a tab change, revise the text and style information according to the selected connector
  public onTabChange(event) {
    this.activeConnectorNo = this.ocppConnectors.findIndex(conn => conn.ocppConnectorId === event.tabId);
    if (this.activeConnectorNo !== -1)
      this.changeOcppValues();
    else
      this.ocppStatus = "No Status";
  }

// Subscribe to ocppconnector table in the database, so it detects the changes in connector data or a new connector is created
// In such a case, ocpp dialog content to the user is revised accordingly
  subscribeWebsocket(): void {
    this.socketService.subscribe('b6fd914e-31f2-4578-ad43-9dbba1325694')
      .pipe(takeUntil(this.destroy$))
      .subscribe(notification => {
        this.websocketCallback(notification);
      });
  }

// Updates connector info if an update notification comes from the web socket
  protected websocketCallback(notification: Notification): void {
    let connectorNo: number;
    let ocppConnectorId: any;
    let ocppStatus: any;
    let ocppStatusTime: any;
    let ocppErrorCode: any;
    let socUnit: any;
    let socValue: any;
    let refChargePointId: any;

    if (notification.eventClass === 'NGSIEvent') {
      if (notification.entityId.includes('OcppConnector')) {
        refChargePointId = notification.eventPayload.content.refId ? notification.eventPayload.content.refId.object :
          ( notification.eventPayload.current.refId ? notification.eventPayload.current.refId.object : null );
// First check if the charge point of the connector is same with the active charge point
        if ( (this.chargePointId === refChargePointId) &&
           ((notification.eventPayload.eventType === NGSIEventType.UPDATE_TEMPORAL) || (notification.eventPayload.eventType === NGSIEventType.CREATE)) )
        {
          ocppConnectorId = notification.eventPayload.content.id ? notification.eventPayload.content.id : '';
// For UPDATE_TEMPORAL type notifications, you read the data from an array, which is different from the CREATE type notifications
          if (notification.eventPayload.eventType === NGSIEventType.UPDATE_TEMPORAL) {
            ocppStatus = notification.eventPayload.content.status ? notification.eventPayload.content.status[0].value : null;
            ocppStatusTime = notification.eventPayload.content.statusTimestamp ? notification.eventPayload.content.statusTimestamp[0].value :
              (notification.eventPayload.content.status ? notification.eventPayload.content.status[0].observedAt : null);
            ocppErrorCode = notification.eventPayload.content.errorCode ? notification.eventPayload.content.errorCode[0].value : null;
            socUnit = notification.eventPayload.content.soc ? notification.eventPayload.content.soc[0].value.unit : null;
            socValue = notification.eventPayload.content.soc ? notification.eventPayload.content.soc[0].value.value : null;
          }
// For CREATE type notifications, you read the data directly not from an array
          else if (notification.eventPayload.eventType === NGSIEventType.CREATE) {
            ocppStatus = notification.eventPayload.content.status ? notification.eventPayload.content.status.value : null;
            ocppStatusTime = notification.eventPayload.content.statusTimestamp ? notification.eventPayload.content.statusTimestamp.value :
              (notification.eventPayload.content.status ? notification.eventPayload.content.status.observedAt : null);
            ocppErrorCode = notification.eventPayload.content.errorCode ? notification.eventPayload.content.errorCode.value : null;
            socUnit = notification.eventPayload.content.soc ? notification.eventPayload.content.soc.value.unit : null;
            socValue = notification.eventPayload.content.soc ? notification.eventPayload.content.soc.value.value : null;
          }
          connectorNo = this.ocppConnectors.findIndex(conn => conn.ocppConnectorId === ocppConnectorId);
// If an existing connector is updated
          if (connectorNo !== -1) {
            if (ocppStatus){
              this.ocppConnectors[connectorNo].ocppStatus = ocppStatus;
              this.ocppConnectors[connectorNo].setOcppIcon(ocppStatus);
            }
            if (ocppStatusTime)
              this.ocppConnectors[connectorNo].ocppStatusTime = ocppStatusTime;
            if (ocppErrorCode)
              this.ocppConnectors[connectorNo].ocppErrorCode = ocppErrorCode;
            if (socUnit)
              this.ocppConnectors[connectorNo].socUnit = socUnit;
            if (socValue)
              this.ocppConnectors[connectorNo].socValue = socValue;
            if (connectorNo === this.activeConnectorNo)
              this.changeOcppValues();
          }
// If a new connector is created
          else {
            this.ocppConnectors.push(new ocppConnector( {
              ocppConnectorId: ocppConnectorId,
              ocppStatus: ocppStatus,
              ocppStatusTime: ocppStatusTime,
              ocppErrorCode: ocppErrorCode,
              socUnit: socUnit,
              socValue: socValue,
            }));
            this.sortConnectors();
            this.changeOcppValues();
          }
        }
      }
    }
  }
}
